/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "../components/Sidebar.css"; // You can refine this if needed
import { TfiAlignJustify } from "react-icons/tfi";
import { IoIosContact } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";

const Sidebar = ({ setIsLoggedIn }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <div className="d-flex">
      {/* Toggle Button */}
     
      {/* Sidebar */}
      {isSidebarOpen && (
        <div
          className="bg-light p-3 border rounded shadow-sm"
          style={{ width: "250px", minHeight: "100vh" }}
        >
          <h5 className="text-center text-primary mb-4">Welcome, SuperAdmin</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <Link to="/Edityourblogs" className="nav-link text-dark">
                <IoIosContact className="me-2" /> All Blogs
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/pendingblogs" className="nav-link text-dark">
                <IoIosContact className="me-2" /> Pending Approval
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/currentusers" className="nav-link text-dark">
                <IoIosContact className="me-2" /> Current Users
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/testimonials" className="nav-link text-dark">
                <IoIosContact className="me-2" /> Add Testimonials
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="/add-employee-appreciation" className="nav-link text-dark">
                <IoIosContact className="me-2" /> Add Employee Appr
              </Link>
            </li>
            <li className="nav-item mt-3">
              <button
                onClick={handleLogout}
                className="btn btn-danger w-100"
              >
                <IoIosContact className="me-2" />
                Logout
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
